module.exports = __webpack_public_path__ + "static/media/united-kingdom.aac0dfef.png";